export enum ERoleMode {
  READ_ONLY = 'READ_ONLY',
  HIDDEN = 'HIDDEN',
  DISABLED = 'DISABLED',
  INVISIBLE = 'INVISIBLE',
}

export enum ERoles {
  CASH = 'CASH',
  EMPL = 'EMPL',
  WHLS = 'WHLS',
  ADMIN = 'ADMIN',
  MNGR = 'MNGR',
}

export enum EResources {
  HOME = 'HOME',
  DOCUMENT_ARCHIVE = 'DOCUMENT_ARCHIVE',
  SETTINGS = 'SETTINGS',
  SETTINGS_CALENDAR = 'SETTINGS_CALENDAR',
  SETTINGS_TAG = 'SETTINGS_TAG',
  SETTINGS_NEWS = 'SETTINGS_NEWS',
}

export enum ERoleActions {
  COUPON_GENERATE = 'COUPON_GENERATE',
  COUPON_BURN = 'COUPON_BURN',
  ANONYMIZE_DATA = 'ANONYMIZE_DATA',
  MANAGE_JOBS = 'MANAGE_JOBS',
  COUPON_GENERATE_UNLIMITED = 'COUPON GENERATE UNLIMITED',

  VIEW_SETTINGS = 'VIEW_SETTINGS',
  VIEW_HOME = 'VIEW_HOME',
  VIEW_DOCUMENT_ARCHIVE = 'VIEW_DOCUMENT_ARCHIVE',
  VIEW_TEMPLATE_ARCHIVE = 'VIEW_TEMPLATE_ARCHIVE',
  VIEW_NEWS_SETTINGS = 'VIEW_NEWS_SETTINGS',
  VIEW_CALENDAR_SETTINGS = 'VIEW_CALENDAR_SETTINGS',
  VIEW_TAG_SETTINGS = 'VIEW_TAG_SETTINGS',

  UPLOAD_FILE = 'UPLOAD_FILE',
  CREATE_FOLDER = 'CREATE_FOLDER',
  UPLOAD_FILE_ON_DOCUMENT_ARCHIVE = 'UPLOAD_FILE_ON_DOCUMENT_ARCHIVE',
  OVERRIDE_FILE = 'OVERRIDE_FILE',
  SEARCH = 'SEARCH',
  FILTER = 'FILTER',
  SHOW_TAG = 'SHOW_TAG',
  RENAME = 'RENAME',
  DELETE = 'DELETE',
  DOWNLOAD = 'DOWNLOAD',
}
